<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">ClickSend Fax Settings</h5>
            </div>
            <div class="row">
                <a href="https://clicksend.com/?u=253180" target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <i data-feather="external-link"></i> <span>ClickSend Fax Sign-Up</span>
                </a>
            </div>

            <form>
                <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="clicksend_username">{{localizationStore.translate('fax.clicksend.username') }}</label>
                                <input type="text" class="form-control" required :placeholder="localizationStore.translate('fax.clicksend.username.placeholder')"
                                    id="clicksend_username" name="clicksend_username"
                                    :data-validation-required-message="localizationStore.translate('fax.clicksend.username.error.message') "
                                    v-model="clicksend_username">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="clicksend_password">{{ localizationStore.translate('fax.clicksend.password') }}</label>
                                <input type="password" class="form-control" required :placeholder="localizationStore.translate('fax.clicksend.password.placeholder')"
                                    id="clicksend_password" name="clicksend_password"
                                    :data-validation-required-message="localizationStore.translate('fax.clicksend.password.error.message')"
                                    v-model="clicksend_password">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls" v-if="clicksend_fax_number">
                                <label class="label-green" for="clicksend_fax_number">{{ localizationStore.translate('fax.clicksend.fax.number') }}</label>
                                <phone-input-component name="clicksend_fax_number" :placeholder="localizationStore.translate('fax.clicksend.fax.number.placeholder')" :prop-phone="clicksend_fax_number"></phone-input-component>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mx-auto">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary mx-auto my-auto" @click="saveClickSend">{{ localizationStore.translate('save.changes') }}</button>
                        &nbsp;&nbsp;
                        <button type="button" data-dismiss="modal"
                            class="btn btn-outline-secondary mx-auto my-auto">{{ localizationStore.translate('close') }}</button>
                        <button
                            type="button"
                            class="btn btn-outline-primary ml-1"
                            @click="isPlayerActive = !isPlayerActive"
                        >
                            <vue-feather size="12" type="film" />
                            Tutorial
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div
        v-if="isPlayerActive"
        class="modal fade text-left show"
        tabindex="-1"
        aria-labelledby="myModalLabel17"
        aria-modal="true"
        role="dialog"
        style="padding-right: 15px;display:block;background: #000000b5;"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="isPlayerActive = !isPlayerActive">
                        <span aria-hidden="true" >×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <vue3-video-player
                            :src="businessStore.tutorials.clickSendFaxSetting"
                            title="Creditfixrr ClickSend Fax Settings"
                        ></vue3-video-player>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import axios from 'axios'
export default{
    components:{

    },
    setup(){
        const clicksend_username = ref(),
        clicksend_password = ref(),
        clicksend_fax_number = ref();
        return{
            clicksend_username,clicksend_password,clicksend_fax_number,
            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
            isPlayerActive: ref(false),
        }
    },
    watch: {
        async 'businessStore.business' (value) {
            this.clicksend_username = value.settings.clicksend_username
            this.clicksend_password = value.settings.clicksend_password
            this.clicksend_fax_number = value.settings.clicksend_fax_number
        },
    },
    methods:{
        saveClickSend(){
            const data= {
                clicksend_username:this.clicksend_username,
                clicksend_password:this.clicksend_password,
                clicksend_fax_number:this.clicksend_fax_number
            }
            const route = this.$router.resolve(
                {
                    name: 'sms-fax-settings',
                }
            );
            axios.put(route.href,data).then(({data})=>{
                if(data.error == false){
                    toastr.success(data.message,'Success')
                }else{
                    toastr.success(data.message,'Error')
                }
            })
        },
        selectMode(val){
            this.mode = val
        }
    }
}
</script>
